import React from 'react'
import styled from 'styled-components'
import { SmallStyle } from 'components/styled/typography/styles'
import { Errors, ModelGetterFn } from 'react-redux-form'
import { I18nComponentType } from 'i18n/i18n-types'
import { mapLanguageToComponentProps } from 'i18n'
import { connect } from 'react-redux'

interface FormErrorsProps {
  model: string | ModelGetterFn
  i18n: I18nComponentType
  show?: boolean | { touched?: boolean; focus?: boolean }
  messages?: object
  expand?: boolean
}

const FormErrorsWrapper = styled.div<{ expand: boolean }>`
  min-height: ${({ theme, expand }) => (expand ? 'auto' : theme.space.s12)};
  height: auto;
  margin-bottom: ${({ theme }) => theme.space.s4};
  color: ${({ theme }) => theme.color.error110};
  line-height: ${({ theme }) => theme.space.s16};
  font-size: ${({ theme }) => theme.space.s12};

  div {
    &::before {
      content: '* ';
    }
  }

  > * {
    ${SmallStyle};
    color: ${({ theme }) => theme.color.error110};
  }
`

export const FormErrors = ({
  model,
  show = { touched: true, focus: false },
  i18n,
  messages,
  expand = false,
}: FormErrorsProps) => (
  <FormErrorsWrapper expand={expand}>
    <Errors
      model={model}
      show={show}
      messages={{ ...i18n.formErrors, ...messages }}
    />
  </FormErrorsWrapper>
)

export default connect(mapLanguageToComponentProps())(FormErrors)
